import { createEnumHelper } from '@seiue/util'

import { PermEnum } from 'packages/sdks-next/growp'

export const PermToRouteName = createEnumHelper(() => ({
  [PermEnum.All]: 'AdminActivities',
  [PermEnum.Activity]: 'AdminActivities',
  [PermEnum.FormalStudent]: 'AdminStudentManagement',
  [PermEnum.FormalTeacher]: 'AdminTeacherManagement',
  [PermEnum.InformalReflection]: 'AdminAdmissions',
  [PermEnum.Paper]: 'AdminTestPaperList',
  [PermEnum.System]: 'AdminSystemSetting',
  [PermEnum.Gateway]: 'AdminGatewayManagement',
  [PermEnum.Information]: 'AdminHotNews',
}))

export const PermToRoutePath = createEnumHelper(() => ({
  [PermEnum.All]: '/admin/activities',
  [PermEnum.Activity]: '/admin/activities',
  [PermEnum.FormalStudent]: '/admin/studentManagement',
  [PermEnum.FormalTeacher]: '/admin/teacherManagement',
  [PermEnum.InformalReflection]: '/admin/admissions',
  [PermEnum.Paper]: '/admin/test-paper',
  [PermEnum.System]: '/admin/systemSetting',
  [PermEnum.Gateway]: '/admin/gatewayManagement',
  [PermEnum.Information]: '/admin/hot-news',
}))
